import SitesReportTable from "./ReportsTable";
import { getSiteReport } from "../../services/ReportService/ReportService";

const CurrentSitesReport = () => {
  return (
    <SitesReportTable
      fetchData={getSiteReport}
      exportFileNamePrefix="City wise Site Status Report"
    />
  );
};

export default CurrentSitesReport;
